import React, { useEffect, useState } from "react";
import "./questions.scss";
import editicon from "../../images/edit-icon.svg";
import closeIcon from "../../images/closeIcon.svg";
import checkIcon from "../../images/checkIcon.svg";
import jsonimage from "../../images/json.svg";
import disablecheckIcon from "../../images/disabled-radio.svg";
import grrencheckIcon from "../../images/greencheck.svg";
import TextInput from "../../commonfields/inputs/TextInput";
import DropdownField from "./DropdownField";
import JsonTooltip from "./JsonTooltip";
import radiobutton from "../../images/radioicon.svg";
import checkedRadiobutton from "../../images/checkedRadio.svg";
import greenCircle from "../../images/greencircle.svg";
import redCircle from "../../images/redCircle.svg";
import Appservice from "../../services/appservice";
import { useParams } from "react-router-dom";
import { catchError } from "../../utils/Utils";
import { AxiosError } from "axios";
import SpinnerModel from "../../commonfields/inputs/SpinnerModel";
import { cloneDeep } from "lodash";



interface FormField {
  fieldtype: string;
  verfied: any;
  fieldName: string;
  section: any;
  coordinates: any;
  id: number;
  name: string;
  value: string;
  type: string;
  isEditing: boolean;
  unique_ids: any;
}


interface IDynamicFormProps {
  initialFields?: FormField[];
  onFieldClick?: Function;
  selectedField?: any;
  handleSelection?: any;
  selectedQuestion:any;
  mappedFields:any;
  onSelectField:Function;
  selectedFieldId:any;

}

const MappingDynamicForm = (props: IDynamicFormProps) => {
  const [fields, setFields] = useState<FormField[]>(props?.initialFields || []);
  const [selectedFieldId, setSelectedFieldId] = useState<number | null>(props.selectedFieldId);
 // const [random, setRandom] = useState<number>(1);
  const [selectedMapFieldIds, setSelectedMapFieldIds] = useState<any>({}); 
  const [removeMapFieldIds, setRemoveMapFieldIds] = useState<any>({}); 
  const [loader, setLoader] = useState<boolean>(false);
  const [activeMappingTab, setactiveMappingTab] = useState('all');
  
 
  
  const service = new Appservice();
  const params = useParams();

  const toggle = (tab: string) => {
    if (activeMappingTab !== tab) {
      setactiveMappingTab(tab);
    }
  };
  
  const handleMappingOptionChange = (id: number) => {
    //setSelectMapFieldIds([...mapFieldIds, id]);
    //props.setSelectedMapField()
    setSelectedFieldId(id);
    //setRandom(new Date().getTime())
    props.onSelectField(id);
    if(props.selectedQuestion && props.mappedFields[props.selectedQuestion]?.includes(id)){
      setRemoveMapFieldIds({
        //...removeMapFieldIds,
        [id]:props.selectedQuestion
      });
      
    } else {
      setSelectedMapFieldIds({
        //...selectedMapFieldIds,
        [id]:props.selectedQuestion
      });
    }
  };



  const addField = (e:any, id:any)=>{
    e?.preventDefault();
    e?.stopPropagation();
    const payload = {
      documentId:params.mappingId,
      fieldId: id,
      questionId:props.selectedQuestion
    }
    service.addQuestionFieldMapping(payload).then((res) => { 
      let _selectedMapFieldIds = cloneDeep(selectedMapFieldIds);
      delete _selectedMapFieldIds[id];
      setSelectedMapFieldIds({
        _selectedMapFieldIds
      });    
      setSelectedFieldId(null);         
      props.handleSelection(props.selectedQuestion,id);
    })

    .catch((error: AxiosError) => {
      catchError(error, true);
    })

    .finally(() => {
      setLoader(false);
    });
   
  
  };

  const removeField = (e:any, id:any)=>{
    e?.preventDefault();
    e?.stopPropagation();
    const payload = {
      documentId:params.mappingId,
      fieldIds: [id],
      questionId:props.selectedQuestion
    }
    service.clearQuestionFieldMapping(payload).then((res) => { 
      let _removeMapFieldIds = cloneDeep(removeMapFieldIds);
      delete _removeMapFieldIds[id];
      setRemoveMapFieldIds({
        _removeMapFieldIds
      });    
      setSelectedFieldId(null);  
      props.handleSelection(props.selectedQuestion,id, 'remove');
    })

    .catch((error: AxiosError) => {
      catchError(error, true);
    })

    .finally(() => {
      setLoader(false);
    });
   
  
  };

  const isMappedField = (field:any)=>{
    const questionIds = Object.keys(props.mappedFields);

    for(let q=0;q<questionIds.length;q++){
       if(props.mappedFields[questionIds[q]]?.includes(field.id)){
         return true;
       }
    }
    return false;
  }

  const displayMappedIcon = (field:any)=>{
   const id = field.id;
   if(props.selectedQuestion){
    if(removeMapFieldIds[id] === props.selectedQuestion){
      return <><span className="removeField" onClick={(e)=>removeField(e, id)}>REMOVE</span><img src={redCircle} alt="Red Radio" id={'m_'+(field.id+'')}/></>
    }
   else if(props.mappedFields[props.selectedQuestion]?.includes(id)){
      return <img src={checkedRadiobutton} alt="Checked Radio" id={'m_'+(field.id+'')}/>
    }
    else if(props.selectedQuestion && selectedMapFieldIds[id] === props.selectedQuestion){
      return <><span className="addField" onClick={(e)=>addField(e, id)}>ADD</span><img src={greenCircle} alt="Green Radio" id={'m_'+(field.id+'')}/></>
    }
   } else {
      if(selectedFieldId === field.id){
        return <img src={checkedRadiobutton} alt="Checked Radio" id={'m_'+(field.id+'')}/>
      }
   }
   const questionIds = Object.keys(props.mappedFields);

   for(let q=0;q<questionIds.length;q++){
      if(props.mappedFields[questionIds[q]]?.includes(id)){
        return <img src={disablecheckIcon} alt="Radio" id={'m_'+(field.id+'')} />
      }
   }

    return <img src={radiobutton} alt="Radio" id={'m_'+(field.id+'')} />
  }


  const handleChange = (
    name: string,
    id: number,
    value: string,
    field: any
  ) => {
    setFields(
      fields.map((field) => (field.id === id ? { ...field, [name]:value } : field))
    );
    const payload = {
      fieldNo: id,
      fieldName: field.fieldName,
      fieldType: field.type,
      section: field.section,
      verified: field.verified,
      documentId: params.documentId,
      [name]: value,
    };
    if (payload.section && payload.fieldName && payload.fieldType) {
       handleSaveDocumentFeildsList(payload);
    }
  };

 

  const handleSaveDocumentFeildsList = (payload: any,cF="") => {  
    setLoader(true);

    service
      .SaveDocumentExtractFields(payload)
      .then((res: any) => {
        setFields(
          fields.map((field) => (field.id === payload.id ? { ...field, verfied:true } : field))
        );
        setLoader(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
    ////
  };
 
  useEffect(() => {
    setFields(props?.initialFields || []);
  }, [props?.initialFields]);

  useEffect(() => {
    setSelectedFieldId(props.selectedFieldId);
  }, [props?.selectedFieldId]);
  useEffect(()=>{
      setSelectedMapFieldIds({});
      setRemoveMapFieldIds({});
  }, [props.selectedQuestion])

 
  return (
    <div className="mapping-dynamicFrom">
    <div className="dynamic-form">
         {/* {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : null} */}
 
      

      {fields.map((field) => (
        <div
          key={field.id}
          className="field-map"
         
        >
          <div className={!props.selectedQuestion && !isMappedField(field)?'radio disabledRadio':'radio'}
           onClick={() => handleMappingOptionChange(field.id)}>
               {displayMappedIcon(field)}
          </div>

          <div
            onClick={() => !(!props.selectedQuestion && !isMappedField(field)) && handleMappingOptionChange(field.id)}
            className={`field-row ${
              (props.selectedQuestion && selectedFieldId === field.id && selectedMapFieldIds[field?.id]  === props.selectedQuestion)
                ? "add-row-select"
                :((props.selectedQuestion && selectedFieldId === field.id && removeMapFieldIds[field?.id]  === props.selectedQuestion)?'remove-row-select'
                : ((selectedFieldId === field.id || (props.selectedQuestion && props.mappedFields[props.selectedQuestion]?.includes(field?.id)))?`row-select`:""))
            }`}
          >
            <div className={`form-field ${field.isEditing ? "editing" : ""}`}>
              {/* <div>{field.name}</div> */}

              <TextInput
                type="text"
                value={field.fieldName}
                placeholder="Enter Field Name"
                className="fieldName"
                readOnly={true}
                onChange={(e: any) =>
                  handleChange("fieldName", field.id, e.target.value, field)
                }
              />
             
            
            </div>

            <div className="dropdown">
              <div className="fieldType"></div>

              <div className="value"><TextInput
               
                //id={field.id}
                //fieldType={field.fieldtype}
                value={field.type}
               // onFieldChange={handleDropdownFieldChange}
                disabled={true}
                //field={field}
                
              /></div>
              <span className="type">Field Type</span>
            </div>
            <div className="json">
              {/* {'{ } JSON'} */}
              </div>

            
          </div>

         
        </div>
      ))}
    </div></div>
  );
};

export default  MappingDynamicForm;
